import { render, staticRenderFns } from "./IconWithText.vue?vue&type=template&id=22ebc734&scoped=true&"
import script from "./IconWithText.vue?vue&type=script&lang=js&"
export * from "./IconWithText.vue?vue&type=script&lang=js&"
import style0 from "./IconWithText.vue?vue&type=style&index=0&id=22ebc734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebc734",
  null
  
)

export default component.exports